<template>
  <div>
    <div class="kpis-agents-container">
      <div class="top-section is-flex-row-center pbottom-2">
        <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_TITLE_KPI_AGENTS') }}{{ interval }}</span>
        <div class="has-text-right">
          <span class="icon is-size-3" @click="closeView">
            <i class="fas fa-times"></i>
          </span>
        </div>
      </div>
      <div class="columns"  v-if="valorationsFiltered">
        <div class="column is-two-fifths">
          <div class="interventions">
            <div class="content">
              <div>
                <span class="value">{{ resume.agentsTotal }}</span>
                <span>{{ CONSTANTS.getCopy('KPIAGENTS_FILTER_INTERVENTIONS') }}</span>
              </div>
              <div class="v-line pleft-1 pright-1"></div>
              <div>
                <span class="value">{{ resume.messagesTotal }}</span>
                <span>{{ CONSTANTS.getCopy('KPIAGENTS_FILTER_MESSAGES') }}</span>
              </div>
              <div class="v-line pleft-1 pright-1"></div>
              <div>
                <span class="value">{{ resume.valorationsTotal }} ({{ resume.percentOK }}%)</span>
                <span>{{ CONSTANTS.getCopy('KPIAGENTS_VALUE_OK') }}</span>
              </div>
            </div>
          </div>
          <div class="interventions-table mtop-2">
            <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_FILTER_TABLE_TITLE_INTERVENTIONS') }}</span>
            <div class="is-flex-row space-between ptop-1">
              <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_FILTER_TABLE_TITLE_AGENT') }}</span>
              <select @change="filterAgents" v-model="agentSelected">
                <option v-for="(agent, index) in agents" :key="'agent'+index" :value="agent.value">{{ agent.name }}</option>
              </select>
              <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_FILTER_TABLE_TITLE_VALUE') }}</span>
              <select @change="filterValorations" v-model="valorationType">
                <option v-for="(type, index) in valorationTypes" :key="'type'+index" :value="parseInt(type.idTypeValoration)">{{ type.typeValoration }}</option>
              </select>
            </div>
            <table class="table is-fullwidth">
              <tr>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_DATE') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_AGENT') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_VALUE') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_USER') }}</th>
              </tr>
              <tr v-for="(intervention, index) in interventionsFiltered" class="cpointer" :key="'intervention'+index" @click="openChat(intervention)">
                <td class="seconds">{{ intervention.date }}</td>
                <td>{{ intervention.agent }}</td>
                <td :class="{'ok': intervention.valoration == 1, 'ko': intervention.valoration == -1}">{{ getValorarion(intervention.valoration) }}</td>
                <td>{{ intervention.user }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="column">
          <div class="consults mtop-2">
            <div class="is-flex-row space-between">
              <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE') }}</span>
              <div><span class="is-bold">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE_ORDER_BY') }}</span>
                <select @change="orderQueriesMade" v-model="queryMadeType">
                  <option :value="parseInt(0)">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE_SELECT') }}</option>
                  <option :value="parseInt(1)">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE_SELECT_#') }}</option>
                  <option :value="parseInt(2)">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE_SELECT_OK') }}</option>
                  <option :value="parseInt(3)">{{ CONSTANTS.getCopy('KPIAGENTS_INQUIRES_MADE_SELECT_KO') }}</option>
                </select>
              </div>
            </div>
            <table class="table is-fullwidth">
              <tr>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_INQUIRE') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_DESCRIPTION') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_#') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_OK') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_TABLE_KO') }}</th>
              </tr>
              <tr v-for="(query, index) in queriesFiltered" :key="'query'+index">
                <td>{{ query.name }}</td>
                <td>{{ query.description }}</td>
                <td>{{ query.total }}</td>
                <td class="ok">{{ query.percentOK }}%</td>
                <td class="ko">{{ query.percentKO }}%</td>
              </tr>
            </table>
          </div>
          <div class="ratings mtop-2">
            <div class="is-flex-row space-between">
              <span class="title">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING') }}</span>
              <div><span class="is-bold">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_ORDER') }}</span>
                <select @change="orderAgentsValorations" v-model="agentValorationType">
                  <option :value="parseInt(0)">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_SELECT') }}</option>
                  <option :value="parseInt(1)">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_OK') }}</option>
                  <option :value="parseInt(2)">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_KO') }}</option>
                  <option :value="parseInt(3)">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_#') }}</option>
                  <option :value="parseInt(4)">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_AGENT') }}</option>
                </select>
              </div>
            </div>
            <table class="table is-fullwidth">
              <tr>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_OPTION_AGENT') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_OPTION_INTERVENTIONS') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_OPTION_OK') }}</th>
                <th>{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_OPTION_KO') }}</th>
              </tr>
              <tr v-for="(valoration, index) in valorationsFiltered" :key="'valoration'+index">
                <td>{{ valoration.agent }}</td>
                <td>{{ valoration.interventions }}</td>
                <td class="ok">{{ valoration.percentOK }}%</td>
                <td class="ko">{{ valoration.percentKO }}%</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="has-text-centered">{{ CONSTANTS.getCopy('KPIAGENTS_AGENTS_RATING_LOADING') }}</div>
    </div>
  </div>
</template>

<script>
import Arrays from '../../lib/Arrays'
export default {
  props: {client: Number, typeSearch: Number, interval: String},
  data () {
    return {
      interventions: null,
      interventionsFiltered: null,
      queries: null,
      queriesFiltered: null,
      resume: null,
      valorations: null,
      agents: null,
      valorationsFiltered: null,
      valorationTypes: null,
      valorationType: -2,
      agentSelected: 0,
      queryMadeType: 0,
      agentValorationType: 0
    }
  },
  created () {
    this.getData()
    this.getValorationTypes()
    this.getAgents()
  },
  methods: {
    getData () {
      this.api.post('/Analitics_Agents', {idClient: this.client, typeSearch: this.typeSearch + 1}).then((response) => {
        this.interventions = response.interventions
        this.interventionsFiltered = response.interventions
        this.queries = response.queries
        this.queriesFiltered = response.queries
        this.resume = response.resume
        this.valorations = response.valorations
        this.valorationsFiltered = response.valorations
      })
    },
    getAgents () {
      this.api.post('/DataAgentsList', {idClient: this.client, typeSearch: this.typeSearch + 1}).then((response) => {
        this.agents = response.agents
      })
    },
    getValorationTypes () {
      this.api.post('/DataTypeValorationList').then((response) => {
        this.valorationTypes = response.typesResponse
      })
    },
    getValorarion (valoration) {
      let text
      switch (valoration) {
        case -1:
          text = 'KO'
          break
        case 1:
          text = 'OK'
          break
        default:
          text = '-'
      }
      return text
    },
    filterAgents () {
      if (parseInt(this.agentSelected) === 0) {
        this.interventionsFiltered = this.interventions
        return
      }
      let agentName = this.agents.filter((element) => element.value === this.agentSelected)
      this.interventionsFiltered = this.interventions.filter((element) => element.agent === agentName[0].name)
    },
    filterValorations () {
      if (this.valorationType === -2) {
        this.interventionsFiltered = this.interventions
        return
      }
      this.interventionsFiltered = this.interventions.filter((element) => element.valoration === this.valorationType)
    },
    orderQueriesMade () {
      switch (this.queryMadeType) {
        case 0:
          this.queriesFiltered = this.queries
          break
        case 1:
          this.queriesFiltered = Arrays.sortMultidimensionalInverse(this.queries, 'total')
          break
        case 2:
          this.queriesFiltered = Arrays.sortMultidimensionalInverse(this.queries, 'percentOK')
          break
        case 3:
          this.queriesFiltered = Arrays.sortMultidimensionalInverse(this.queries, 'percentKO')
          break
      }
    },
    orderAgentsValorations () {
      switch (this.agentValorationType) {
        case 0:
          this.valorationsFiltered = this.valorations
          break
        case 1:
          this.valorationsFiltered = Arrays.sortMultidimensionalInverse(this.valorations, 'percentOK')
          break
        case 2:
          this.valorationsFiltered = Arrays.sortMultidimensionalInverse(this.valorations, 'percentKO')
          break
        case 3:
          this.valorationsFiltered = Arrays.sortMultidimensionalInverse(this.valorations, 'interventions')
          break
        case 4:
          this.valorationsFiltered = Arrays.sortMultidimensionalInverse(this.valorations, 'agents')
          break
      }
    },
    openChat (intervention) {
      if (this.client === undefined) {
        window.open(`/#/chats/${parseInt(intervention.idUser)}`, '_blank')
        return
      }
      window.open(`/#/clients/${this.client}/chats/${parseInt(intervention.idUser)}`, '_blank')
    },
    closeView () {
      this.$emit('closeView')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analytics/KpiAgents.vue